<template>
    <p class="tw-mt-6 tw-mb-2 tw-text-lg tw-font-semibold tw-leading-6 offer-item-title">
        {{ offer.name }}
        <span v-if="offer.group_num > 1">({{ translate('offers.persons', [offer.group_num]) }})</span>
    </p>
    <div class="tw-mb-4">
        <button
            v-if="detailsAvailable"
            @click="expandDetails"
            class="tw-text-sm tw-mb-2 tw-underline tw-font-semibold offer-details-btn"
        >
            {{ detailsExpanded ? translate('offers.hide_details') : translate('offers.show_details') }}
        </button>
        <transition name="fade">
            <div class="tw-text-sm tw-mb-8 tw-text-grey-200" v-if="detailsExpanded">
                <p v-if="offer.description" class="tw-mb-2">
                    {{ offer.description }}
                </p>
                <div v-if="offer.duration" class="tw-mb-2">
                    <p class="offer-details-label tw-font-semibold">{{ translate('offers.duration') }}</p>
                    <p>{{ formatDuration }}</p>
                </div>
                <div v-if="offer.difficulty" class="tw-mb-2">
                    <p class="offer-details-label tw-font-semibold">{{ translate('offers.difficulty') }}</p>
                    <p>{{ offer.difficulty }}</p>
                </div>
            </div>
        </transition>
    </div>
    <div
        class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-pb-8 tw-border-0 tw-border-b tw-border-grey-100 tw-border-solid preview"
    >
        <div>
            <img :src="groupPeopleIcon" alt="Number of people" />
        </div>
        <div
            class="tw-flex tw-flex-row tw-items-center tw-justify-around tw-min-w-[84px] tw-p-2 tw-bg-white tw-border tw-border-solid tw-border-light-grey2 tw-rounded-md"
        >
            <div
                @click.prevent="REMOVE_OFFER(offer)"
                class="tw-cursor-pointer tw-border-2 tw-border-solid tw-rounded-[4px] tw-inline-block tw-text-white tw-text-sm tw-leading-[0.5] tw-p-2 quantity"
                :class="[offerQuantity(offer) === 0 ? 'tw-pointer-events-none tw-opacity-60' : '']"
            >
                -
            </div>
            <label class="tw-text-lg tw-font-semibold tw-min-w-[12px] tw-mx-2">
                {{ peopleNum(offer) }}
            </label>
            <div
                @click.prevent="SET_OFFER(offer)"
                class="tw-cursor-pointer tw-border-2 tw-border-solid tw-rounded-[4px] tw-inline-block tw-text-white tw-text-sm tw-leading-[0.5] tw-p-2 quantity"
                :class="[totalPeople >= maxPeople ? 'tw-pointer-events-none tw-opacity-60' : '']"
            >
                +
            </div>
        </div>
        <label class="tw-text-lg tw-font-semibold tw-min-w-[12px] tw-mx-2">
            {{ offer.discounted_price_formatted }}
        </label>
    </div>
</template>
<script>
import groupPeopleIcon from '@images/group-people.svg';
import i18n from '@js/vue/mixins/i18n';
import { mapGetters, mapMutations } from 'vuex';
import { trackBookingOffersExpand } from '@js/vue/dataLayerUtils';

export default {
    props: ['offer'],
    inject: ['translations'],
    mixins: [i18n],
    data() {
        return {
            groupPeopleIcon,
            detailsExpanded: false,
        };
    },
    computed: {
        ...mapGetters('booking', ['getMaxPeople', 'getOfferQuantity', 'getPeopleNum', 'getTotalPeople',
            'getServiceTitle', 'getRegionCategorySlugs']),
        maxPeople() {
            return this.getMaxPeople;
        },
        totalPeople() {
            return this.getTotalPeople;
        },
        offerQuantity() {
            return this.getOfferQuantity;
        },
        peopleNum() {
            return this.getPeopleNum;
        },
        formatDuration() {
            return this.offer.duration / 60 + 'h';
        },
        detailsAvailable() {
            return this.offer.duration || this.offer.difficulty || this.offer.description;
        },

        title()
        {
            return this.getServiceTitle;
        },

        regionCategorySlugs() {
            return this.getRegionCategorySlugs;
        },
    },
    methods: {
        ...mapMutations('booking', ['SET_OFFER', 'REMOVE_OFFER']),
        expandDetails() {
            if (!this.detailsExpanded) trackBookingOffersExpand(this.title, this.regionCategorySlugs['category-slug']);
            this.detailsExpanded = !this.detailsExpanded;
        },
    },
};
</script>
